<script lang="ts">
    import RewardsIcon from "@apps/rewards/components/RewardsIcon.svelte";
    import { SvelteComponent } from "svelte";

    import Image from "@components/Image/Image.svelte";

    //Props
    export let customerIcon: string | null | undefined;
    export let defaultIcon: typeof SvelteComponent;

    //Optional props
    export let alt = "Reward Icon";
    export let iconSize: "small" | "medium" | "large" | "fullWidth" = "medium";
    export let viewBox: string | null = null;
    export let objectFit: "contain" | "cover" = "contain";
</script>

<div class="gw-rd-dynamic-customer-icon">
    {#if customerIcon}
        <Image src={customerIcon} {objectFit} loading="lazy" {alt} />
    {:else}
        <RewardsIcon size={iconSize} {viewBox}>
            <svelte:component this={defaultIcon} />
        </RewardsIcon>
    {/if}
</div>

<style>
    .gw-rd-dynamic-customer-icon {
        display: flex;
        --gw-image-backdrop-color: transparent;
    }
</style>
